// shadcn Theme Configuration
// Converts MUI theme colors to CSS variables and utility functions

export const themeColors = {
  // Primary color from MUI theme
  primary: "#539d65",

  // Secondary colors from comments
  secondary: "#122137",
  secondaryLight: "#566986",

  // Background colors
  backgroundGreen: "#f1fcf4",
  backgroundBlue: "#e6e9ed",

  // Derived colors for shadcn theme system
  primaryForeground: "#ffffff",
  secondaryForeground: "#ffffff",
};

// Convert hex to HSL for shadcn CSS variables
export const hexToHsl = (hex) => {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h, s, l;

  l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // achromatic
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
      default: h = 0;
    }
    h /= 6;
  }

  return [
    Math.round(h * 360),
    Math.round(s * 100),
    Math.round(l * 100)
  ];
};

// Generate HSL values for CSS variables
export const themeHslColors = {
  primary: hexToHsl(themeColors.primary),
  secondary: hexToHsl(themeColors.secondary),
  secondaryLight: hexToHsl(themeColors.secondaryLight),
  backgroundGreen: hexToHsl(themeColors.backgroundGreen),
  backgroundBlue: hexToHsl(themeColors.backgroundBlue),
};

// Export CSS variable strings for use in stylesheets
export const cssVariables = {
  // Map to shadcn theme variables
  primary: `${themeHslColors.primary[0]} ${themeHslColors.primary[1]}% ${themeHslColors.primary[2]}%`,
  secondary: `${themeHslColors.secondary[0]} ${themeHslColors.secondary[1]}% ${themeHslColors.secondary[2]}%`,
  accent: `${themeHslColors.secondaryLight[0]} ${themeHslColors.secondaryLight[1]}% ${themeHslColors.secondaryLight[2]}%`,

  // Background variants
  backgroundGreen: `${themeHslColors.backgroundGreen[0]} ${themeHslColors.backgroundGreen[1]}% ${themeHslColors.backgroundGreen[2]}%`,
  backgroundBlue: `${themeHslColors.backgroundBlue[0]} ${themeHslColors.backgroundBlue[1]}% ${themeHslColors.backgroundBlue[2]}%`,
};

// Utility function to apply theme to document root
export const applyTheme = (isDark = false) => {
  const root = document.documentElement;

  if (isDark) {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }

  // Set custom theme variables
  root.style.setProperty('--primary', cssVariables.primary);
  root.style.setProperty('--secondary', cssVariables.secondary);
  root.style.setProperty('--accent', cssVariables.accent);
  root.style.setProperty('--background-green', cssVariables.backgroundGreen);
  root.style.setProperty('--background-blue', cssVariables.backgroundBlue);
};

// Export theme object for compatibility
export const theme = {
  colors: themeColors,
  cssVariables,
  applyTheme,
};
